import React from 'react';
import FeaturedSlider from '../featuredSlider/FeaturedSlider';

const VanCar = ({ data, loading }) => {

    const vanCar = data?.filter((item) => item?.bodyType?.toLowerCase() === "van");

    return (
        <div>
            {loading && <h5 className="fs-18 mt-50 text-center">Loading</h5>}

            {vanCar?.length > 0 && !loading && <FeaturedSlider cars={vanCar} featuredClass="car-slider" />}

            {vanCar?.length === 0 && !loading && <h5 className="fs-18 mt-50 text-center">No Data Avilable</h5>}
        </div>
    );
};

export default VanCar;